export const defaultAccountsFilterState = {
  name: '',
  customer_id: null,
  assigned_user_id: '',
  date_from: '',
  date_to: '',
  comment: '',
  is_launched: '',
  geo: '',
};

export const defaultAccountsFilterColumns = [
  {key: 'name', label: 'Имя', type: 'multi-text'},
  {key: 'customer_id', label: 'ID клиента', type: 'text'},
  {key: 'assigned_user_id', label: 'Назначен', type: 'select', options: []},
  {key: 'date_from', label: 'Дата от', type: 'date'},
  {key: 'date_to', label: 'Дата до', type: 'date'},
  {key: 'comment', label: 'Комментарий', type: 'text'},
  {key: 'is_launched', label: 'В работе', type: 'switch'},
  {key: 'geo', label: 'Гео', type: 'geo'},
];

export const defaultAccountsFormState = {
  customerIdMasked: '',
  name: '',
  link: '',
  profileId: '',
};

export const defaultAccountsModalState = {
  open: false,
  openAddAccount: false,
  openAssign: false,
  openTemplateCampaign: false,
  openTemplateCreateCampaign: false,
};
